export default __webpack_public_path__ + "static/media/Patient_on_bed.92f91bb3.svg";